import { Input, InputProps } from '@/components/shadcn/input';

interface ExtendedInputProps extends InputProps {
  labelTitle: string;
}

export function InputGroup(props: ExtendedInputProps) {
  const { labelTitle, ...inputProps } = props;
  return (
    <div>
      <label className='text-gray-settings'>{labelTitle}</label>

      <Input className='mt-3' {...inputProps} />
    </div>
  );
}
